import { render, staticRenderFns } from "./TeamSelectionModal.vue?vue&type=template&id=f89b1f10&scoped=true"
import script from "./TeamSelectionModal.vue?vue&type=script&lang=js"
export * from "./TeamSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./TeamSelectionModal.vue?vue&type=style&index=0&id=f89b1f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89b1f10",
  null
  
)

export default component.exports